import "./date-modal.scss";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { FunctionComponent } from "react";

import { ReactComponent as CloseIcon } from "@client/components/reusable/SvgIcons/library/close_icon2.svg";
import { getCurrentDayAndMonth } from "@client/helpers/getCurrentDayAndMonth";

import SvgIcon from "../reusable/SvgIcons";

interface DateModalProps {
	orderDate: string;
	orderId: string;
	closeModal?: (e) => void;
}

const DateModal: FunctionComponent<DateModalProps> = ({
	orderDate,
	orderId,
	closeModal,
}) => {
	function getDateFormat(orderDate: string) {
		dayjs.extend(utc);
		const dayjsUtc = dayjs.utc(orderDate);
		const localDate = dayjsUtc.local().format();
		const dayAndMonth = getCurrentDayAndMonth(localDate);
		const hour = dayjs(localDate).hour();
		const sanitizedHour = hour < 10 ? `0${hour}` : hour;
		const minute = dayjs(localDate).minute();
		const sanitizedMinute = minute < 10 ? `0${minute}` : minute;

		return `${dayAndMonth} ${sanitizedHour}:${sanitizedMinute}`;
	}

	function handleCloseModal(e) {
		e.preventDefault();
		e.stopPropagation();
		closeModal(e);
	}

	return (
		<div className="date-modal-wrapper">
			<SvgIcon
				component={CloseIcon}
				className="date-modal-close-btn"
				onClick={(e) => handleCloseModal(e)}
			/>
			<div className="date-modal-content">{`Order ${orderId} created at ${getDateFormat(
				orderDate
			)}`}</div>
		</div>
	);
};

export default DateModal;
